import { combineReducers } from 'redux';

import { Language } from 'ha/i18n';
import availableLanguages, * as availableLanguagesSelectors from './availableLanguages';
import currentLanguage, * as currentLanguageSelectors from './language';
import localisedLocations, * as localisedLocationsSelectors from './localisedLocations';

import { LanguageSwitcherState } from '../types';

export default combineReducers({
  availableLanguages,
  currentLanguage,
  localisedLocations,
});

export const getCurrentLanguageCode = (state: LanguageSwitcherState) =>
  currentLanguageSelectors.getCode(state.currentLanguage);

export const getAvailableLanguages = (state: LanguageSwitcherState) =>
  availableLanguagesSelectors.getAvailableLanguages(state.availableLanguages);

export const getLocalisedLocation = (
  state: LanguageSwitcherState,
  lang: Language,
) =>
  localisedLocationsSelectors.getLocalisedLocation(
    state.localisedLocations,
    lang,
  );

export const isLanguageAvailable = (
  state: LanguageSwitcherState,
  lang: Language,
) =>
  availableLanguagesSelectors.isLanguageAvailable(
    state.availableLanguages,
    lang,
  );
